"use client";

import { AiSection } from "@/components/about/ai-section";
import { AttentionSection } from "@/components/about/attention-section";
import { FeaturedGamesSection } from "@/components/about/featured-games-section";
import { HeroSection } from "@/components/about/hero-section";
import { MathematicalSection } from "@/components/about/mathematical-section";
import ParallaxSpaceBg from "@/components/about/parallax-space-bg";
import { PiShootingStars } from "@/components/about/pi-shooting-stars";
import { TeachersSection } from "@/components/about/teachers-section";
import { TestimonialsCarousel } from "@/components/about/testimonials-carousel";
import { ValuePropSection } from "@/components/about/value-prop";
import { FeaturedBannersV2 } from "@/components/feature/featured-banners/featured-banners-v2";
import { Footer } from "@/components/layout/footer";
import { Header } from "@/components/layout/header";

export function MarketingPageV2() {
  return (
    <main className="relative min-h-screen flex flex-col">
      {/* Parallax background (texture + purple grade + shooting stars) */}
      <ParallaxSpaceBg>
        <PiShootingStars />
      </ParallaxSpaceBg>
      <div className="relative z-10">
        <Header />

        <div className="flex-1">
          <HeroSection />
          <TestimonialsCarousel />
          <ValuePropSection />
          <AttentionSection />
          <AiSection />
          <MathematicalSection />
          <TeachersSection />
          <FeaturedBannersV2 />
          <FeaturedGamesSection />
        </div>

        <Footer />
      </div>
    </main>
  );
}

export default MarketingPageV2;
